// import * as React from "react";
// import Button from "@mui/material/Button";
// import Dialog from "@mui/material/Dialog";


// import DialogTitle from "@mui/material/DialogTitle";
// import { Link, useNavigate } from "react-router-dom";
// import { axiosClient } from '../../../../utils/auth.util';
// import { DialogContent } from "@mui/material";

// const hasPassedExam = localStorage.getItem("hasPassedExam");

// export default function TutorExamEndDialog(props) {
//   const [isPage, setIsPage] = React.useState(true);
//   const history = useNavigate();

//   const dashboardEntry = async () => {
//     let tutor1 = JSON.parse(localStorage.getItem("tutor"));
//     let tutor_ls = tutor1.saveTutor;

//     let temp_tutorSaveObj = {
//       ...tutor_ls,
//       tutStatus: "db",
//     };
//     let temp_tutorObj = {
//       ...tutor1,
//       saveTutor: temp_tutorSaveObj,
//     };
//     localStorage.setItem("tutor", JSON.stringify(temp_tutorObj));

//     try {
//       const res = await axiosClient.post(
//         `/tutorweb/setTutStatus/${tutor_ls.tutor_id}`,
//         { tutStatus: "db" }
//       );
//       if (res.data) {
//         history("/register-dashboard", { replace: true });
//         window.location.reload();
//       } else {
//         console.log("not saved tutStatus in db");
//       }
//     } catch (err) {
//       console.error("Error updating tutStatus:", err);
//     }
//   };

//   const tryAnotherExam = () => {
//     history("/register-dashboard/tutor_exam",{replace:true});
//     window.location.reload();
//   };

//   const saveInTutorMain = async () => {
//     const tutorInfo = JSON.parse(
//       window.localStorage.getItem("tutor")
//     )?.saveTutor;
//     const tutorRatingVal = await axiosClient.get(
//       `tutorweb/getTutorRating/${
//         JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id
//       }`
//     );
//     // props.setTemp_tutExam(temp_tutorObj)
//     const ratingVal = tutorRatingVal?.data?.ratingVal;
//     let marksVal = +props.result * 4;
//     let initialRating = ratingVal
//       ? marksVal > 70 && marksVal <= 75
//         ? (+ratingVal + 6) / 2
//         : marksVal > 75 && marksVal <= 80
//         ? (+ratingVal + 7) / 2
//         : marksVal > 80 && marksVal <= 85
//         ? (+ratingVal + 8) / 2
//         : marksVal > 85 && marksVal <= 90
//         ? (+ratingVal + 9) / 2
//         : marksVal > 90 && (+ratingVal + 10) / 2
//       : marksVal > 70 && marksVal <= 75
//       ? 6
//       : marksVal > 75 && marksVal <= 80
//       ? 7
//       : marksVal > 80 && marksVal <= 85
//       ? 8
//       : marksVal > 85 && marksVal <= 90
//       ? 9
//       : marksVal > 90 && 10;
//     // console.log({tutorRatingVal , marksVal , initialRating})
//     let postData1 = {
//       tutor_id: tutorInfo?.tutor_id,
//       name: tutorInfo?.name,
//       email: tutorInfo?.email,
//       dept: tutorInfo?.dept,
//       rating: initialRating ? initialRating?.toFixed(2) + "" : null,
//       highest_degree: tutorInfo?.highest_degree,
//       university: tutorInfo?.academic_info[0]?.college,
//       watsNumber: tutorInfo?.wa_id,
//       writer: tutorInfo?.writer,
//       tags: props?.subject[0],
//     };
//     const updateTutorInfo = await axiosClient.post(
//       `https://central-device-apis.el.r.appspot.com/api/tutorweb/updateTutorInfoWithRating/${
//         JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutor_id
//       }`,
//       postData1
//     );
//     // `http://localhost:8800/api/tutorweb/updateTutorInfo/${JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutor_id}`,postData1)
//     if (updateTutorInfo.data) {
//       console.log({
//         testTagsDev1: JSON.parse(localStorage.getItem("tutor"))?.saveTutor
//           ?.tutor_exam[-1]?.subject,
//       });
//       console.log("updated the tutor database");
//     } else {
//       console.log("tutor database not updated");
//     }
//   };

//   React.useEffect(() => {
//     if (!props.subject || props?.subject?.length === 0) {
//       console.log({ subjectCheck: props.subject });
//       setIsPage(false);
//     } else {
//       if (
//         JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutStatus ===
//           "db" ||
//         JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutStatus ===
//           "exl"
//       ) {
//         saveInTutorMain();
//       }
//     }
//   }, []);

//   return (
//     <React.Fragment>
//       <Dialog
//         open={props.open}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//         maxWidth="md"
//         fullWidth
//         // onClose={props.onClose}
//       >
//         <DialogContent>
//           <div>
//             {isPage && (
//               <div
//                 role="main"
//                 class="form-all max-w-screen-md mx-auto"
//                 // style={{ marginLeft: "27%", marginTop: "11rem", width: "50%" }}
//               >
//                 <ul class="form-section page-section">
//                   <li
//                     id="cid_1"
//                     class="form-input-wide"
//                     data-type="control_head"
//                   >
//                     <div class="form-header-group  header-default">
//                       <div class="header-text httac htvam">
//                         <h2
//                           id="header_1"
//                           class="form-header"
//                           data-component="header"
//                           style={{ textAlign: "center" }}
//                         >
//                           Tutor Registration Test
//                         </h2>
//                       </div>
//                     </div>
//                   </li>
//                   <li>
//                     <div id="cid_13" class="form-input-wide">
//                       <div id="text_13" class="form-html" data-component="text">
//                         <div
//                           style={{
//                             textAlign: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <strong style={{ color: "darkorange" }}>
//                             You have successfully submitted
//                           </strong>
//                           <div
//                             style={{
//                               marginTop: "10%",
//                               marginBottom: "5%",
//                               backgroundColor: "#f2ffff",
//                             }}
//                           >
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                               }}
//                             >
//                               <span style={{ flex: "50%" }}> Exam Id : </span>
//                               <p style={{ flex: "50%" }}>{props.examId}</p>
//                             </div>
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                               }}
//                             >
//                               <span style={{ flex: "50%" }}> Subject : </span>
//                               <p style={{ flex: "50%" }}>{props.subject}</p>
//                             </div>
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                               }}
//                             >
//                               <span style={{ flex: "50%" }}> Marks : </span>
//                               <p style={{ flex: "50%" }}>
//                                 {+props.result * 4}/100
//                               </p>
//                             </div>
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                               }}
//                             >
//                               <span style={{ flex: "50%" }}> Status : </span>{" "}
//                               <p
//                                 style={{
//                                   color:
//                                     props.resultStatus === "fail"
//                                       ? "red"
//                                       : "green",
//                                   flex: "50%",
//                                 }}
//                               >
//                                 {props.resultStatus}
//                               </p>
//                             </div>
//                           </div>

//                           {props.resultStatus === "fail" && (
//                             <span style={{ color: "red" }}>
//                               Sorry,You are not able to qualify this test. Good
//                               luck for next time!!
//                               <div
//                                 style={{
//                                   marginTop: "10px",
//                                   marginBottom: "30px",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <Button
//                                   variant="contained"
//                                   className="ctaBtn"
//                                   onClick={tryAnotherExam}
//                                   style={{
//                                     background: "#03d6d7",
//                                     borderRadius: "35px",
//                                     fontSize: "15px",
//                                   }}
//                                 >
//                                   Try Another Subject
//                                 </Button>
//                               </div>
//                             </span>
//                           )}
//                           {props.resultStatus === "pass" && (
//                             <span style={{ color: "green" }}>
//                               Congrats!! You have qualified this test
//                               <div
//                                 style={{
//                                   marginTop: "10px",
//                                   marginBottom: "30px",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <Button
//                                   variant="contained"
//                                   className="ctaBtn"
//                                   onClick={() => {
//                                     if (!hasPassedExam) {
//                                       dashboardEntry();
//                                     } else {
//                                       props.setCurrentQuestionSet(2);
//                                       props.onClose();
//                                     }
//                                   }}
//                                   style={{
//                                     background:
//                                       "linear-gradient(127deg, #03D757, #11A1DC)",
//                                     borderRadius: "35px",
//                                     fontSize: "15px",
//                                   }}
//                                 >
//                                   {hasPassedExam ? "Try Other" : "Dashborad"}
//                                 </Button>
//                               </div>
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </li>

//                   <li style={{ display: "none" }}>
//                     Should be Empty:
//                     <input type="text" name="website" value="" />
//                   </li>
//                 </ul>
//               </div>
//             )}

//             {!isPage && (
//               <div style={{ textAlign: "center", marginTop: "10%" }}>
//                 <h1 style={{ color: "black" }}>404</h1>
//                 <h1 style={{ color: "black" }}>Not Found</h1>
//                 <br />
//                 <h3 style={{ color: "black" }}>Invalid Grant!!</h3>
//               </div>
//             )}
//           </div>
//         </DialogContent>
//       </Dialog>
//     </React.Fragment>
//   );
// }


import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Link, useNavigate } from "react-router-dom";
import { axiosClient } from '../../../../utils/auth.util';
import { DialogContent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateUserData } from "../../../../redux/slice/registerSlice";

export default function TutorExamEndDialog(props) {
  const [isPage, setIsPage] = React.useState(true);
  const history = useNavigate();
  const dispatch = useDispatch();
  
  // Get userData from Redux instead of localStorage
  const userData = useSelector(state => state.register.userData);

  const dashboardEntry = async () => {
    // Update Redux state instead of localStorage
    dispatch(updateUserData({ tutStatus: "db" }));

    try {
      const res = await axiosClient.post(
        `/tutorweb/setTutStatus/${userData?.tutor_id || userData?._id}`,
        { tutStatus: "db" }
      );

      if (res.data) {
        history("/register-dashboard", { replace: true });
        window.location.reload();
      } else {
        console.log("not saved tutStatus in db");
      }
    } catch (err) {
      console.error("Error updating tutStatus:", err);
    }
  };

  const tryAnotherExam = () => {
    history("/register-dashboard/tutor_exam", { replace: true });
    window.location.reload();
  };

  const saveInTutorMain = async () => {
    if (!userData) {
      console.error("No user data available");
      return;
    }

    const tutorRatingVal = await axiosClient.get(
      `tutorweb/getTutorRating/${userData?.tutor_id || userData?._id}`
    );

    const ratingVal = tutorRatingVal?.data?.ratingVal;
    let marksVal = +props.result * 4;
    let initialRating = ratingVal
      ? marksVal > 70 && marksVal <= 75
        ? (+ratingVal + 6) / 2
        : marksVal > 75 && marksVal <= 80
        ? (+ratingVal + 7) / 2
        : marksVal > 80 && marksVal <= 85
        ? (+ratingVal + 8) / 2
        : marksVal > 85 && marksVal <= 90
        ? (+ratingVal + 9) / 2
        : marksVal > 90 && (+ratingVal + 10) / 2
      : marksVal > 70 && marksVal <= 75
      ? 6
      : marksVal > 75 && marksVal <= 80
      ? 7
      : marksVal > 80 && marksVal <= 85
      ? 8
      : marksVal > 85 && marksVal <= 90
      ? 9
      : marksVal > 90 && 10;

    let postData1 = {
      tutor_id: userData?.tutor_id || userData?._id,
      name: userData?.fullName || userData?.name,
      email: userData?.email,
      dept: userData?.department,
      rating: initialRating ? initialRating?.toFixed(2) + "" : null,
      highest_degree: userData?.highest_degree,
      university: userData?.academic_info?.[0]?.college,
      watsNumber: userData?.whatsappNumber?.number,
      writer: userData?.writer,
      tags: props?.subject?.[0],
    };

    const updateTutorInfo = await axiosClient.post(
      `https://central-device-apis.el.r.appspot.com/api/tutorweb/updateTutorInfoWithRating/${
        userData?.tutor_id || userData?._id
      }`,
      postData1
    );

    if (updateTutorInfo.data) {
      console.log("updated the tutor database");
    } else {
      console.log("tutor database not updated");
    }
  };

  React.useEffect(() => {
    if (!props.subject || props?.subject?.length === 0) {
      console.log({ subjectCheck: props.subject });
      setIsPage(false);
    } else {
      if (
        userData?.tutStatus === "db" ||
        userData?.tutStatus === "exl"
      ) {
        saveInTutorMain();
      }
    }
  }, [props.subject, userData]);

  return (
    <Dialog open={true} maxWidth="md" fullWidth>
      {isPage && (
        <>
          <DialogTitle>Tutor Registration Test</DialogTitle>
          <DialogContent>
            <div style={{ padding: "20px", textAlign: "center" }}>
              <h3>You have successfully submitted</h3>
              
              <div style={{ margin: "20px 0" }}>
                <p><strong>Exam Id:</strong> {props.examId}</p>
                <p><strong>Subject:</strong> {props.subject}</p>
                <p><strong>Marks:</strong> {+props.result * 4}/100</p>
                <p><strong>Status:</strong> {props.resultStatus}</p>
              </div>

              {props.resultStatus === "fail" && (
                <div style={{ color: "red", margin: "20px 0" }}>
                  <p>Sorry, You are not able to qualify this test. Good luck for next time!!</p>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={tryAnotherExam}
                    style={{ marginTop: "10px" }}
                  >
                    Try Another Subject
                  </Button>
                </div>
              )}

              {props.resultStatus === "pass" && (
                <div style={{ color: "green", margin: "20px 0" }}>
                  <p>Congrats!! You have qualified this test</p>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={dashboardEntry}
                    style={{
                      background: "linear-gradient(127deg, #03D757, #11A1DC)",
                      borderRadius: "35px",
                      fontSize: "15px",
                      marginTop: "10px"
                    }}
                  >
                    Dashboard
                  </Button>
                </div>
              )}
            </div>
          </DialogContent>
        </>
      )}

      {!isPage && (
        <DialogContent>
          <div style={{ textAlign: "center", padding: "40px" }}>
            <h2>404</h2>
            <h3>Not Found</h3>
            <p>Invalid Grant!!</p>
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
}
